<script setup>
  import ComponentAlert from "@components/Alerts/Alert.vue";
  import ComponentCard from "@components/Cards/Card.vue";

  defineOptions({name: "PagesMergeAccountError"});
</script>

<template>
  <ComponentCard title="Accounts verknüpfen" :test-id="getTestId()">
    <section>
      <ComponentAlert class="mt-4" type="error">{{ $page.props.error }}</ComponentAlert>

      <!-- TODO: we might explain here (again), how the MigrateAccount process works -->
    </section>
  </ComponentCard>
</template>
